module.exports = __webpack_public_path__ + "static/media/cursos_Certificados.71c539be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cursos_Certificados.jpg
// module id = 1791
// module chunks = 0